// ----------------------------------------------------------------------
// V2 Modern Typography System

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm)
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md)
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg)
    }
  };
}

const FONT_PRIMARY = 'Public Sans, sans-serif'; // Google Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  fontWeightExtraBold: 800, // V2 for stat numbers
  h1: {
    fontWeight: 800, // V2: Extra bold for impact
    lineHeight: 1.35,
    fontSize: pxToRem(40),
    letterSpacing: -0.5,
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 })
  },
  h2: {
    fontWeight: 800,
    lineHeight: 1.35,
    fontSize: pxToRem(32),
    letterSpacing: -0.25,
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 })
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 })
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 })
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 })
  },
  h6: {
    fontWeight: 700,
    lineHeight: 1.55,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 })
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16)
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 1.57,
    fontSize: pxToRem(14)
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16)
  },
  body2: {
    lineHeight: 1.57,
    fontSize: pxToRem(14)
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12)
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: 1.2, // V2: Slightly more spacing
    textTransform: 'uppercase'
  },
  button: {
    fontWeight: 600, // V2: Slightly lighter for elegance
    lineHeight: 1.71,
    fontSize: pxToRem(14),
    textTransform: 'none' // V2: No transform for modern look
  },
  // V2 CUSTOM VARIANTS
  statNumber: {
    fontWeight: 800,
    lineHeight: 1.2,
    fontSize: pxToRem(32),
    letterSpacing: -0.5
  },
  statLabel: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: 1,
    textTransform: 'uppercase'
  },
  cardTitle: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(18)
  },
  menuItem: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(14)
  }
};

export default typography;
